import { Logo } from 'components/common/Logo';
import { SearchIcon } from 'components/link/SearchIcon';
import { FilterCart } from 'features/FilterCart';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { NavigationContainer, NavigationItem, NavigationSearchWrapper } from './components';

export class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNavAvailable: false,
      mounted: false,
      is404: false
    };
  }

  componentDidMount = () => this.setState({ mounted: true });

  shouldComponentUpdate = (nextProps, nextState) => {
    const { isNavAvailable, is404 } = this.state;
    const { isNavAvailable: nextIsNavAvailable } = nextState;

    const { app, filter } = this.props;
    const { rootCountyId } = app;
    const { selectedId } = filter;

    const { app: nextApp, filter: nextFilter } = nextProps;
    const { rootCountyId: nextRootCountyId } = nextApp;
    const { selectedId: nextSelectedId } = nextFilter;

    if (!isNavAvailable || is404 !== nextProps.is404) return true;
    if (
      nextRootCountyId !== rootCountyId ||
      nextSelectedId !== selectedId ||
      nextIsNavAvailable !== isNavAvailable
    )
      return true;

    return false;
  };

  componentDidUpdate(prevProps) {
    const { app, is404 } = this.props;
    const { mainNav, sideNav } = app;
    if (mainNav && sideNav) {
      if (mainNav.length && sideNav.length) this.setState({ isNavAvailable: true, is404 });
    } else if (prevProps && prevProps.is404 !== is404) {
      this.setState({ is404 });
    }
  }

  render() {
    const {
      app: { searchUrl }
    } = this.props;

    const is404 = this.state.is404;

    return (
      <>
        <NavigationContainer id="main-navigation">
          {!is404 && <FilterCart />}
          <NavigationSearchWrapper>
            <SearchIcon searchIcon to={searchUrl} />
          </NavigationSearchWrapper>
          <NavigationItem>
            <a href="/">
              <Logo />
            </a>
          </NavigationItem>
        </NavigationContainer>
      </>
    );
  }
}

const mapStateToProps = ({ filter, app, navigation }) => ({
  filter: {
    lastId: filter.last.id,
    selectedId: filter.selected.id,
    countyCategories: filter.categoryList
  },
  app: {
    sideNav: app.sideNav,
    mainNav: app.mainNav,
    rootCountyId: app.settings.rootCounty,
    searchUrl: app.search
  }
});

export default connect(mapStateToProps, null)(Navigation);

Navigation.propTypes = {
  app: PropTypes.shape({
    sideNav: PropTypes.array,
    mainNav: PropTypes.array,
    hamburgerNav: PropTypes.array
  })
};
